import axios from "axios";

const api = process.env.VUE_APP_API_KEY;

export const fetchContentSection = async (id) => {
  try {
    const response = await axios.get(
      `${api}/api/content-sections/?return_all=true`
    );
    return response.data.items.find((x) => x.id === id);
  } catch (error) {
    console.error("Error fetching content:", error);
    throw error;
  }
};

export const formatContent = (content) => {
  if (!content) return ""; // Return empty if no content

  // Trim any extra spaces around the content
  let formattedContent = "";
  let tempContent = content.trim();

  // Split content by period (.) or Khmer full stop (។)
  const sentences = tempContent.split(/(?<=\.|។)/); // Split by period or Khmer full stop

  let line = "";
  sentences.forEach((sentence) => {
    const sentenceWithDot = sentence.trim(); // Ensure sentence ends with a period or full stop

    // If line length is under 500 characters, add to the current line
    if (line.length + sentenceWithDot.length <= 500) {
      line += sentenceWithDot + " "; // Add space after sentence
    } else {
      // Otherwise, add the current line to formattedContent and start a new line
      formattedContent += line.trim() + "<br><br>";
      line = sentenceWithDot + " "; // Start new line with the current sentence
    }
  });

  // Add any remaining content in the last line
  if (line.length > 0) {
    formattedContent += line.trim();
  }

  return formattedContent; // Return the formatted content with <br> tags
};

export const fetchSlider = async (id) => {
  try {
    const response = await axios.get(`${api}/api/sliders`);
    return response.data.items.find((x) => x.id === id);
  } catch (error) {
    console.error("Error fetching content:", error);
    throw error;
  }
};
